export const ru = {
    fetchError: 'Не удалось выполнить запрос, попробуйте позже.',
    pageHeader: 'Анкета специалиста: {fullName}',
    saveError: 'Не удалось обновить анкету, попробуйте позже.'
};
